import { stripeSecretKey } from './StripeStore';

export const updateStripeSecretKey = (value) => stripeSecretKey.update(oldValue => value);
